module.exports = __webpack_public_path__ + "img/app-store-simple-white.c7a2c259.svg";